import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { Platform, StatusBar } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { signInStyles, SIGN_IN_OUTER_BACKGROUND } from '../styles/signIn.styles';

/**
 * Wraps public auth screens so layout respects notch / home indicator / browser safe-area
 * (viewport-fit=cover) consistently across Chrome, Brave, and native.
 */
export function SignInFlowSafeArea({ children }: { children: ReactNode }) {
  useFocusEffect(
    useCallback(() => {
      if (Platform.OS !== 'android') return;
      // Match app.json default light status bar content; only fix the window color strip.
      StatusBar.setBarStyle('light-content');
      StatusBar.setBackgroundColor(SIGN_IN_OUTER_BACKGROUND);
    }, []),
  );

  return (
    <SafeAreaView style={signInStyles.flowSafeRoot} edges={['top', 'left', 'right', 'bottom']}>
      {children}
    </SafeAreaView>
  );
}
